import keys from '@debbie/common/dist/cache/keys.js'
import {
  CaseStatus,
  getCollectorOnCase,
} from '@debbie/common/dist/cases/index.js'
import {
  PaymentPlanStatus,
  Plan,
  getCurrentPaymentPlan,
} from '@debbie/common/dist/economy/payment-plans/index.js'
import { PaymentMethodStatus } from '@debbie/common/dist/payment-methods/index.js'
import * as paymentPlansAPI from '@debbie/cortex/dist/api/payment-plans.js'
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js'
import { useCase } from '@debbie/cortex/dist/cases/index.js'
import { useCollector } from '@debbie/cortex/dist/collectors/index.js'
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js'
import { useCustomer } from '@debbie/cortex/dist/customers/index.js'
import { c, h } from '@debbie/cortex/dist/index.js'
import { useMe, useRole } from '@debbie/cortex/dist/me/index.js'
import {
  paymentPlansEntity,
  usePaymentPlansByCaseId,
} from '@debbie/cortex/dist/paymentPlans/index.js'
import q from '@debbie/cortex/dist/query.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { useTenant } from '@debbie/cortex/dist/tenant/index.js'
import { Col, Container, Row } from '@debbie/iris/dist/components/Grid/index.js'
import ArrowLeft from '@debbie/iris/dist/components/Icons/ArrowLeft.js'
import {
  Content,
  PageBase,
  Panel,
  PlaceholderLoader,
  Progress,
} from '@debbie/iris/dist/components/index.js'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
// @ts-ignore
import { styled } from 'styled-components'

import { CaseFooter, Info, Step } from '../../components/index.js'
import { Steps } from '../../components/Step.js'
import { APIBASE } from '../../config.js'

const CreatePaymentPlan = () => {
  const params = useParams<{ id: string }>()
  const { id } = params

  const lang = useSelector((s: RootState) => s.lang)
  const meLoadable = useMe()
  const me = h.hasData(meLoadable) ? meLoadable.data : null
  const meRole = useRole()

  const caseIdLoader = useCase(id)
  const caseId = h.hasData(caseIdLoader) ? caseIdLoader.data.caseId : null
  const singleCaseLoader = useCase(caseId)
  const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null

  const paymentPlansLoadable = usePaymentPlansByCaseId(singleCase?.caseId)
  const paymentPlans = h.hasData(paymentPlansLoadable)
    ? paymentPlansLoadable.data
    : null
  const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId)
  const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null

  const creditorLoadable = useCreditor(singleCase?.creditorId)
  const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null

  const customerLoader = useCustomer(singleCase?.customerId)
  const customer = h.hasData(customerLoader) ? customerLoader.data : null

  const tenant = useTenant()

  const collectorLoadable = useCollector(
    (singleCase &&
      creditor &&
      getCollectorOnCase(
        singleCase.type,
        singleCase.collectorId,
        creditor.identityCollectorId,
        creditor.defaultCollectorId,
      )) ||
      undefined,
  )
  const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null

  const [skipGatherInfo, setSkipGatherInfo] = useState(false)

  const [hasNescessaryInfo, setHasNescessaryInfo] = useState(false)

  const paymentPlan: Plan | null = getCurrentPaymentPlan(paymentPlans)

  const debtorUser =
    me && customer && customer.users.find((user) => user.userId === me.id)

  let STEP: Steps = Steps.SELECTPLAN

  if (!paymentPlan) {
    STEP = Steps.SELECTPLAN
  } else if (
    paymentPlan.status === PaymentPlanStatus.CREATED &&
    !skipGatherInfo &&
    !hasNescessaryInfo
  ) {
    STEP = Steps.GATHERINFO
  } else if (
    paymentPlan.plan.length !== 0 &&
    !paymentPlan.documentSignedAt &&
    paymentPlan.status === PaymentPlanStatus.CREATED &&
    tenant?.settings.disablePaymentPlanSigning !== true
  ) {
    STEP = Steps.SIGNING
  } else if (
    paymentPlan.paymentMethodStatus !== PaymentMethodStatus.SAVED &&
    paymentPlan.plan.length !== 0
  ) {
    STEP = Steps.CONNECTCARD
  } else {
    STEP = Steps.CONGRATULATIONS
  }

  useEffect(() => {
    if (
      debtorUser &&
      debtorUser.details.email &&
      debtorUser.details.phone &&
      debtorUser.details.address &&
      (customer.isCompany ? debtorUser.details.cvr : debtorUser.details.cpr)
    ) {
      setHasNescessaryInfo(true)
    }
  }, [debtorUser])

  return (
    <div>
      <Content fullHeight>
        <PageBase>
          <Container>
            {singleCase?.status === CaseStatus.ENDED ? (
              <h3>{lang.debtorWeb.congratsCaseEnd}</h3>
            ) : (
              <div>
                {singleCase && (
                  // @ts-ignore
                  <Link
                    to={`/cases/${singleCase.id}`}
                    style={{
                      textDecoration: 'none',
                    }}
                  >
                    <p
                      style={{
                        color: 'grey',
                        fontSize: '.8em',
                      }}
                    >
                      <b>
                        <ArrowLeft style={{ margin: '-.2em 0px' }} />{' '}
                        {lang.debtorWebPaymentPlans.backToCase}
                      </b>
                    </p>
                  </Link>
                )}
                <Row>
                  <StyledCol size="md" width="3">
                    <Panel
                      header={
                        singleCase
                          ? `${lang.debtorWebPaymentPlans.paymentPlanOn} #${singleCase.id}`
                          : ''
                      }
                    >
                      <div>
                        <br />
                        <div>
                          <Progress
                            items={(
                              [] as {
                                title: string
                                active: boolean
                                onClick?: () => Promise<void>
                              }[]
                            )
                              .concat(
                                !paymentPlan || paymentPlan?.createdByMe
                                  ? [
                                      {
                                        title:
                                          lang.debtorWebPaymentPlans.selectPlan,
                                        active: STEP === Steps.SELECTPLAN,
                                        onClick:
                                          paymentPlan &&
                                          paymentPlan.status !==
                                            PaymentPlanStatus.ACTIVE &&
                                          paymentPlan.createdByMe
                                            ? async () => {
                                                try {
                                                  await paymentPlansAPI.del(
                                                    paymentPlan.paymentPlanId,
                                                  )
                                                  q.invalidate(
                                                    keys.write.modify(
                                                      paymentPlansEntity,
                                                      paymentPlan.paymentPlanId,
                                                    ),
                                                  )
                                                } catch (error) {
                                                  console.error(error)
                                                  alert(
                                                    'An error occured. Please try again.',
                                                  )
                                                }
                                              }
                                            : undefined,
                                      },
                                    ]
                                  : [],
                              )
                              .concat(
                                hasNescessaryInfo
                                  ? []
                                  : [
                                      {
                                        title:
                                          lang.debtorWebPaymentPlans.gatherInfo,
                                        active: STEP === Steps.GATHERINFO,
                                      },
                                    ],
                              )
                              .concat(
                                tenant?.settings.disablePaymentPlanSigning ===
                                  true
                                  ? []
                                  : [
                                      {
                                        title: lang.debtorWebPaymentPlans.sign,
                                        active: STEP === Steps.SIGNING,
                                      },
                                    ],
                              )
                              .concat([
                                {
                                  title:
                                    lang.debtorWebPaymentPlans.paymentMethod,
                                  active: STEP === Steps.CONNECTCARD,
                                },
                                {
                                  title: lang.debtorWebPaymentPlans.approval,
                                  active: STEP === Steps.CONGRATULATIONS,
                                },
                              ])}
                          />
                        </div>
                        <br />
                        {caseVouchers && singleCase && me && (
                          <Info
                            caseVouchers={caseVouchers}
                            singleCase={singleCase}
                            me={me}
                          />
                        )}
                      </div>
                      {!(singleCase && paymentPlans) && <PlaceholderLoader />}
                    </Panel>
                    {collector && (
                      <p style={{ textAlign: 'center' }}>
                        {collector && collector.logo ? (
                          <img
                            height="35px"
                            alt={collector.logo.fileName}
                            src={`${APIBASE}/files/${collector.logo.fileId}/${collector.logo.fileName}`}
                          />
                        ) : (
                          <span>{collector.name}</span>
                        )}
                      </p>
                    )}
                  </StyledCol>
                  <Col size="md" width="9">
                    {singleCase && caseVouchers && paymentPlans && meRole && (
                      <Step
                        singleCase={singleCase}
                        paymentPlan={paymentPlan}
                        caseVouchers={caseVouchers}
                        meRole={meRole}
                        step={STEP}
                        onSkipGatherInfo={() => setSkipGatherInfo(true)}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            )}
          </Container>
        </PageBase>
        <CaseFooter collector={collector} />
      </Content>
    </div>
  )
}

export default CreatePaymentPlan

const StyledCol = styled(Col)`
  display: none;

  @media (min-width: 992px) {
    display: block;
  }
`
